import React, { useRef, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Menu } from 'primereact/menu';
import { Menubar } from 'primereact/menubar';
import { Avatar } from 'primereact/avatar';
import logo from '../../assets/image/logo.png';
import { AuthContext } from '../../Context/AuthContext';

export default function Header() {
  const { auth, logout } = useContext(AuthContext);
  const user = auth?.user;
  const navigate = useNavigate();
  const menuRef = useRef(null);
  const mobileMenuRef = useRef(null);

  const basePath = user?.role === "admin" ? "/admin" : "/client";

  const accountMenu = [
    {
      label: 'Change Password',
      icon: 'pi pi-refresh',
      command: () => {
        navigate(`${basePath}/dashboard/change-password`);
        menuRef.current?.hide({ currentTarget: menuRef.current.container });
      },
    },
    {
      label: 'Logout',
      icon: 'pi pi-sign-out',
      command: () => {
        logout();
        navigate('/login');
        menuRef.current?.hide({ currentTarget: menuRef.current.container });
      },
    },
  ];

  const mainMenu = [
    { label: "Country", icon: "pi pi-globe", command: () => navigate(`${basePath}/dashboard/country`) },
    { label: "Language", icon: "pi pi-language", command: () => navigate(`${basePath}/dashboard/language`) },
    { label: "Source", icon: "pi pi-book", command: () => navigate(`${basePath}/dashboard/source`) },
    { label: "Product", icon: "pi pi-file-edit", command: () => navigate(`${basePath}/dashboard/product`) },
    { label: "Translation", icon: "pi pi-file-edit", command: () => navigate(`${basePath}/dashboard/translation`) },
  ];

  const homeIcon = (
    <i
      className="pi pi-home cursor-pointer p-6"
      style={{ fontSize: '1.5rem', color: 'white' }}
      onClick={() => navigate(`${basePath}/dashboard`)}
    />
  );

  return (
    <div>
      <div className="flex justify-content-between align-items-center px-4 py-1">
        <div className="flex align-items-center gap-3">
          <img
            src={logo}
            alt="Logo"
            style={{ width: '100px', height: '60px', cursor: 'pointer' }}
            onClick={() => navigate(`${basePath}/dashboard`)}
          />
        </div>
        
        <div className="flex align-items-center gap-3">
          {/* <div>
            <Avatar
              icon="pi pi-user"
              shape="circle"
              style={{ backgroundColor: '#FC5F1CFF', color: '#ffffff', cursor: 'pointer' }}
              onClick={(e) => menuRef.current?.toggle(e)}
            />
            <div style={{ fontSize: '0.78rem', marginTop: '2px', fontWeight: 'bold', color: '#6C6C6C' }}>
              {user?.role === "admin" ? "Admin" : "Client"}
            </div> */}
          {/* </div> */}
          <div className="text-right">
            <div style={{ fontWeight: '600', color: '#FC5F1CFF' }}>{user?.name || 'Unknown'}</div>
            <div style={{ fontSize: '0.85rem', opacity: 0.8, color: '#000000' }}>{user?.email || 'unknown@gmail.com'}</div>
          </div>

          <div>
            <Avatar
              icon="pi pi-cog"
              shape="circle"
              style={{ backgroundColor: '#FC5F1CFF', color: '#ffffff', cursor: 'pointer' }}
              onClick={(e) => menuRef.current?.toggle(e)}
            />
          </div>

          <Menu model={accountMenu} popup ref={menuRef} />
        </div>
      </div>

      <div className="relative">
        <div className="hidden md:flex justify-content-center">
          <Menubar
            model={mainMenu}
            start={homeIcon}
            style={{
              backgroundColor: '#FC5F1CFF',
              border: 'none',
              height: '4rem',
              display: "flex",
              width: "100%",
              alignItems: 'center',
              justifyContent: 'center',
            }}
            pt={{
              root: { className: 'flex w-full items-center' },
              menu: { className: 'justify-content-center w-full' },
              label: { className: 'text-white font-bold px-4 py-2' },
              icon: { style: { fontSize: '1rem', color: 'white' } },
              menuitem: { className: 'transition-colors duration-200 cursor-pointer' },
            }}
          />
        </div>

        <Menu
          model={mainMenu}
          start={homeIcon}
          popup
          ref={mobileMenuRef}
          style={{ width: '220px', backgroundColor: '#FC5F1CFF' }}
          pt={{
            menuitem: {
              className: 'px-4 py-3 mb-1 rounded transition-colors duration-200',
              style: { color: 'black', justifyContent: 'flex-start' },
            },
          }}
        />
      </div>
    </div>
  );
}
